export default "__VITE_ASSET__82e7Pv90__"